/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Seats_LabelInputs */



/**
* | output |
* | --- |
* | "Seats" |
*
* @param {Team_Manager_Seats_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_seats_label = /** @type {((inputs?: Team_Manager_Seats_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Seats_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Places")
	if (locale === "de") return /** @type {LocalizedString} */ ("Plätze")
	if (locale === "it") return /** @type {LocalizedString} */ ("Postazioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Места")
	if (locale === "es") return /** @type {LocalizedString} */ ("Puestos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("席位")
	if (locale === "ja") return /** @type {LocalizedString} */ ("シート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सीटें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Lugares")
	return /** @type {LocalizedString} */ ("Seats")
});